import React, { Component, createContext } from 'react';

import { connect } from 'react-redux';

import { Box } from '@mui/material';

import UserBreadcrumbs from '~/components/Common/Elements/UserBreadcrumbs';

import { getOrderDetail } from '../../../services/OrdersService';
import UsersService from '../../../services/UsersService';
import Spinner from '../../Common/Spinner';

import OrderBookingPage from './OrderBookingPage';

const Context = createContext<{
  order: App.Order;
  user: App.User;
}>({
  order: null,
  user: null,
});

type OrderBookingPageContainerProps = {
  match: {
    params: {
      id_orders: string;
    };
  };
};

type OrderBookingPageContainerState = {
  isReady: boolean;
  dataError: string;
  order?: App.Order;
  customer?: App.User;
};

export class OrderBookingPageContainer extends Component<
  OrderBookingPageContainerProps,
  OrderBookingPageContainerState
> {
  constructor(props: OrderBookingPageContainerProps) {
    super(props);

    this.state = {
      isReady: false,
      dataError: '',
    };
  }

  componentDidMount() {
    this.refreshData().catch((err) => {
      this.setState({ dataError: err });
    });
  }

  refreshData = async () => {
    this.setState({ isReady: false }, async () => {
      const {
        match: { params },
      } = this.props;

      let order;
      try {
        order = await getOrderDetail(params.id_orders);
      } catch (e) {
        this.setState({ dataError: e.message });
        return;
      }
      const customer = await UsersService.getUser(order.fk_customer_id);

      this.setState({
        isReady: true,
        order,
        customer,
      });
    });
  };

  render() {
    const { order, customer, isReady } = this.state;
    const { dataError } = this.state;

    if (dataError) {
      return <div className="alert alert-danger">Failed to load data: {dataError}</div>;
    }

    if (!isReady) {
      return <Spinner />;
    }

    const orderId = this.props.match.params.id_orders;

    return (
      <Box component="div" className="container">
        <UserBreadcrumbs orderId={orderId} currentPage="Booking details" />
        <Context.Provider value={{ order, user: customer }}>
          <OrderBookingPage order={order} customer={customer} refreshData={this.refreshData} />
        </Context.Provider>
      </Box>
    );
  }
}

export default connect(null, {})(OrderBookingPageContainer);
